const diary = document.querySelector('.diary');

if (diary) {
    const children = diary.childNodes;
    let isEmpty = true;

    children.forEach((item) => {
        if (item.nodeName === 'LI') isEmpty = false;
    });

    if (isEmpty) diary.parentElement.style.display = 'none';
}
